import type { FlowSuggestion } from "@stockline/shared/types/ai/flow-suggestion"
import type { OfflineResourceConfig } from "../../../types"
import { FLOW_SUGGESTION_TABLE } from "./db"

export const flowSuggestionConfig: OfflineResourceConfig<FlowSuggestion> = {
  name: "flow-suggestions",
  endpoints: {
    full: "/api/v2/flow-suggestions",
    delta: "/api/v2/flow-suggestions/changes",
    push: "/api/v2/flow-suggestions/changes",
  },
  tableName: FLOW_SUGGESTION_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    targetId: "targetId",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
  // Tombstones stay in Dexie (pulls deliver them as upserts carrying
  // `deletedAt`); readers filter `deletedAt` themselves.
  softDelete: true,
}
